<template>
    <div class="nevs-content">
        <NevsCard class="form">
            <div class="assistance-disclaimer" v-html="$LANG.Get('texts.assistanceDisclaimer')"></div>
            <div class="assistance-email-note">{{ $LANG.Get('texts.assistanceEmailNote').replace('%email%', $store.state.user.email) }}</div>
            <NevsTextArea class="message-field" v-model="message" :error="messageError"
                          :label="$LANG.Get('fields.assistanceMessage')"></NevsTextArea>
            <NevsUpload v-model="attachment" :label="$LANG.Get('fields.assistanceAttachment')"></NevsUpload>
            <div class="send-button">
                <NevsButton @click="send">{{ $LANG.Get('buttons.send') }}</NevsButton>
            </div>
        </NevsCard>
    </div>
</template>

<script>
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsUpload from "@/components/nevs/NevsUpload.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";

export default {
    name: "ModuleAssistance",
    components: {NevsCard, NevsButton, NevsUpload, NevsTextArea},
    data() {
        return {
            message: '',
            attachment: {name: '', link: '', id: 0},
            messageError: ''
        }
    },
    methods: {
        send() {
            let valid = true;
            this.messageError = '';
            if (this.message.trim() === '') {
                this.messageError = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            }
            if (!valid) return;
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm',
                text: this.$LANG.Get('alerts.assistanceSendQuestion'),
                callback: (response) => {
                    if (response) {
                        vm.$API.APICall('post', 'assistance/send', {
                            message: vm.message,
                            attachment: vm.attachment
                        }, (data, success) => {
                            if (success) {
                                vm.$LOCAL_BUS.TriggerEvent('notification', {
                                    type: 'alert',
                                    message: vm.$LANG.Get('alerts.assistanceSent')
                                });
                                vm.message = '';
                                vm.attachment = {name: '', link: '', id: 0};
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'assistance');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.assistance'),
                link: null
            }
        ]);
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.assistance-disclaimer {
    padding: 5px;
    font-size: 16px;
}

.assistance-email-note {
    padding: 5px;
    margin-bottom: 10px;
    font-size: 14px;
    color: $muted-text;
}

.form {
    max-width: 600px;
}

.message-field :deep(.nevs-text-area) {
    min-height: 200px;
}

.send-button {
    padding: 5px;
    margin-top: 10px;
}
</style>
